import _ from "lodash";
import * as z from "../../../framework";
import UploadPicturePopUp from "../../../framework/controls/uploadPicturePopup";
import { ComponentOptions } from "../../components/components/component";
import { TemplateComponent } from "../../components/components/templateComponent";
import K_Picture from "../templates/K_Picture";

// tslint:disable-next-line:no-var-requires
var loadingUrl = require("!file-loader!../../../../Content/app/icon/Loading_48.GIF").default;

export interface PictureOptions extends ComponentOptions {
    templateIconWidth: string;
    bsc?: string;
    containerId?: string;
    templateIconClasses?: string;
    overlayMessage?: string;
    overlayIconClasses?: string;
    pictureClasses?: string;
}

export class Picture extends TemplateComponent {
    options: PictureOptions;
    attachmentId: number;
    change: (attachmentId: number) => void;
    updating: boolean;

    constructor(options: PictureOptions) {
        super(K_Picture, options);
    }

    preRender() {
        const options = this.options;

        options.containerId = options.containerId || this.id + "_Container";
        options.overlayMessage = options.overlayMessage || "ChangePicture";
        options.overlayIconClasses = options.overlayIconClasses || "far fa-camera";
    }

    create() {
        var me = this;

        $(window).resize(() => {
            me.resize();
        });

        $(`#${me.id}_Overlay`).bind("click", () => {
            var uploadPicturePopup = new UploadPicturePopUp({
                success: (e) => {
                    if (e.response && e.response.d && e.response.d.results) {
                        if (me.change) {
                            me.change(e.response.d.results[0]);
                        }
                    }
                }
            });

            uploadPicturePopup.popUp({});
        });

        me.update();
    }

    // Sets the attachmentId and updates the picture.
    setAttachmentId(attachmentId: number) {
        var me = this;

        if (!attachmentId || me.attachmentId != attachmentId) {
            me.attachmentId = attachmentId;
            if (!me.updating) {
                me.updating = true;
                me.update().done(() => {
                    me.updating = false;
                });
            }
        }
    }

    // The function passed in will be called whenever the attachmentId is changed using the UI.
    onChange(change: (attachmentId: number) => void) {
        var me = this;

        me.change = change;
    }

    // Updates the picture with the picture associated with the current attachmentId.
    update() {
        var me = this;
        var container = $(`#${me.id}`);
        var deferred = $.Deferred();

        $(`#${me.id}_Overlay`).hide();
        container.empty();
        container.css("font-size", "");
        container.append(`<img class="picture-loading" src="${loadingUrl}"></img>`);
        me.resize();

        if (me.attachmentId) {
            z.ajax({
                url: "Attachment/ActivateAttachment?id=" + me.attachmentId,
                type: "GET"
            }).done(function (response) {
                var url = z.util.buildMediaUrl(response.d.results);
                container.append(`<img class="picture-image" src="${url}"></img>`);
                me.resize();
                container.children(".picture-image").load(() => {
                    container.children(".picture-loading").remove();
                    $(`#${me.id}_Overlay`).show();
                    me.resize();
                    deferred.resolve();
                });
            });
        } else {
            container.empty();
            container.css("font-size", me.options.templateIconWidth);
            container.append(`<i class="${me.options.templateIconClasses}"></i>`);
            $(`#${me.id}_Overlay`).show();
            me.resize();
            deferred.resolve();
        }

        return deferred;
    }

    private resize() {
        var me = this;

        setTimeout(() => {
            var container = $(`#${me.id}`);
            var width = container.width();
            container.css("height", "");
            if (container.children("img").length > 0) {
                container.children(".picture-image").width(width);
            } else {
                container.children(".picture-image").css("width", "");
            }
            var overlay = $(`#${me.id}_Overlay`);
            overlay.width(width);
            overlay.height(container.height());
        }, 100);
    }
}
